// タップ時にホバーと同じ演出を再生

const SELECTOR = ".btn, .top-btn, .sponsor .head";
const DURATION = 700;

export const initTapFeedback = () => {
	document.addEventListener(
		"pointerdown",
		(e) => {
			if (e.pointerType !== "touch" || !(e.target instanceof Element)) return;
			const el = e.target.closest(SELECTOR);
			if (!el) return;

			// 連続タップで頭から再生
			el.classList.remove("is-tapped");
			// eslint-disable-next-line no-void
			void el.offsetWidth;
			el.classList.add("is-tapped");
			clearTimeout(el.tapTimer);
			el.tapTimer = setTimeout(() => el.classList.remove("is-tapped"), DURATION);
		},
		{ passive: true },
	);
};

export default initTapFeedback;
